import {QRCodeSVG} from 'qrcode.react'
import {useParams} from 'react-router-dom'
import {CloseButton} from '@headlessui/react'
import {useTranslation} from 'react-i18next'

import {Button, CopyButton, DialogNew} from '@sdox/ui'
import {IconCopy} from '@sdox/icons'
import {IconExternalLinkLarge} from '@sdox/icons/large'

import {useFolderShare} from '../../../hooks/useFolderShare'

import type {DialogContentProps} from '@sdox/ui'

export interface ShareProps extends DialogContentProps {
  isOpen: boolean
  onClose: () => void
}

export const Share = ({
  isOpen,
  onClose,
}: ShareProps) => {
  const {basePath, seFolderSlug} = useParams()
  const {folderUrl, openMail} = useFolderShare()
  const {t} = useTranslation()

  return (
    <DialogNew
      open={isOpen}
      onClose={onClose}
      heading={'Mappe teilen'}
      size={'small'}
      persistent={false}
    >
      <DialogNew.Content>
        <div className={'@container'}>
          <div className={'flex flex-col items-center justify-between gap-spacing-24 border-b border-outline-secondary py-spacing-24 @[380px]:flex-row'}>
            <span id={'share-via-email'}>E-Mail senden</span>
            <span className={'flex size-spacing-72 items-center justify-center'}>
              <Button
                className={'w-spacing-56'}
                onClick={openMail}
                mboAttrs={{prefix: 'ShareDialog', piece: 'SendEmail'}}
                size={'medium'}
                variant={'outline'}
                aria-labelledby={'share-via-email'}
              >
                <IconExternalLinkLarge/>
              </Button>
            </span>
          </div>
          <div className={'flex flex-col items-center justify-between gap-spacing-24 border-b border-outline-secondary py-spacing-24 @[380px]:flex-row'}>
            <span id={'share-via-link'}>Link kopieren</span>
            <span className={'flex size-spacing-72 items-center justify-center'}>
              <CopyButton
                copyContent={folderUrl}
                className={'w-spacing-56'}
                mboAttrs={{prefix: 'ShareDialog', piece: 'CopyLink'}}
                size={'medium'}
                variant={'outline'}
                aria-labelledby={'share-via-link'}
              />
            </span>
          </div>
          <div className={'flex flex-col items-center justify-between gap-spacing-24 pt-spacing-24 @[380px]:flex-row'}>
            <div className={'flex flex-col items-center @[380px]:items-start'}>
              <div id={'share-via-qrcode'}>QR-Code scannen</div>
              <div className={'text-center text-p2 text-glyph-default-secondary @[380px]:text-start'}>
                (Ideal für den Einsatz auf dem Smartphone)
              </div>
            </div>
            <QRCodeSVG
              role={'img'}
              aria-labelledby={'share-via-qrcode'}
              size={72}
              value={`${window.location.origin}/${basePath}/${seFolderSlug}`}
            />
          </div>
        </div>
      </DialogNew.Content>
      <DialogNew.Footer className={'flex justify-end'}>
        <CloseButton
          as={Button}
          variant={'outline'}
          size={'medium'}
        >
          {t('common:close')}
        </CloseButton>
      </DialogNew.Footer>
    </DialogNew>
  )
}
